import $ from 'jquery'
import 'select2/dist/js/select2.full.js'

export default class {
  init () {
    this.initSelects()
  }

  initSelects () {
    let employmentTypeSelect = $('#me-umantis-field-filter-employment-type')
    let jobTypeSelect = $('#me-umantis-field-filter-job-type')
    let locationSelect = $('#me-umantis-field-filter-location')

    employmentTypeSelect.select2({
      allowClear: true,
      dropdownAutoWidth: true,
      placeholder: employmentTypeSelect.data('placeholder'),
      dropdownCssClass: 'dropdown--product',
      width: '100%'
    })

    employmentTypeSelect.on('select2:open', function () {
      $('.select2-search--dropdown .select2-search__field')
        .attr('placeholder', employmentTypeSelect.data('placeholder-inline'))
    })

    employmentTypeSelect.on('select2:close', function () {
      $('.select2-search--dropdown .select2-search__field')
        .attr('placeholder', null)
    })

    jobTypeSelect.select2({
      allowClear: true,
      dropdownAutoWidth: true,
      placeholder: jobTypeSelect.data('placeholder'),
      dropdownCssClass: 'dropdown--product',
      width: '100%'
    })

    jobTypeSelect.on('select2:open', function () {
      $('.select2-search--dropdown .select2-search__field')
        .attr('placeholder', jobTypeSelect.data('placeholder-inline'))
    })

    jobTypeSelect.on('select2:close', function () {
      $('.select2-search--dropdown .select2-search__field')
        .attr('placeholder', null)
    })

    locationSelect.select2({
      placeholder: locationSelect.data('placeholder'),
      width: '100%',
      dropdownCssClass: 'dropdown--product',
      dropdownAutoWidth: true
    })
  }
}



// WEBPACK FOOTER //
// ../htdocs/web/fileadmin/global/js/src/components/jobfinder.js